"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const react_data_table_component_1 = __importDefault(require("react-data-table-component"));
const React = __importStar(require("react"));
const react_1 = require("react");
const router_1 = require("next/router");
const Spinner_1 = __importDefault(require("../Animation/Spinner"));
const Checkbox_1 = __importDefault(require("../Input/Checkbox"));
const TableContext_1 = __importDefault(require("../../contexts/TableContext"));
function Table(props) {
    var _a, _b;
    const { paginator, title, actions } = props;
    const [rowsPerPage, setRowsPerPage] = react_1.useState(20);
    const onChangeRowsPerPage = react_1.useCallback((newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
    }, [setRowsPerPage]);
    const router = router_1.useRouter();
    const defaultPage = parseInt(`${(_a = router.query.page) !== null && _a !== void 0 ? _a : 1}`, 10);
    const { setTargetPage, data, lastFetchedPage = 1, status, totalRows } = paginator;
    const onChangePage = react_1.useCallback((page, totalRows) => {
        setTargetPage(page);
    }, [setTargetPage]);
    return (React.createElement(TableContext_1.default.Provider, { value: { paginator } }, paginator.error
        ? React.createElement("div", { className: "flex items-center justify-center w-full p-4 text-center" }, paginator.error.message)
        : (React.createElement(react_data_table_component_1.default, Object.assign({ progressPending: status === 'loading', progressComponent: React.createElement(Spinner_1.default, null), data: (_b = paginator.getDataByPage(lastFetchedPage)) !== null && _b !== void 0 ? _b : [], highlightOnHover: true, noHeader: !title && !actions, paginationDefaultPage: defaultPage, onChangeRowsPerPage: onChangeRowsPerPage, pagination: true, onChangePage: onChangePage, paginationPerPage: rowsPerPage, paginationRowsPerPageOptions: [20, 30, 40, 50], paginationServer: true, paginationTotalRows: totalRows, pointerOnHover: true, selectableRowsComponent: Checkbox_1.default }, props)))));
}
exports.Table = Table;
